export enum LogsType {
  CANCEL_ORDER = 'logDeliveryOrderCancel',
  EDIT_ORDER = 'logDeliveryOrderEdit',
  CREATE_ORDER = 'logDeliveryOrderCreate',
}
